import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { index, integer, text } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/**
 * Taiwan list metadata for a grapheme. Sourced from Taiwan MOE character charts. Row is
 * absent for graphemes outside every Taiwan list.
 */
export const graphemeTwDataTable = staticTable(
  "grapheme_tw_data",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    tbclLevel: integer("tbcl_level"),

    usageClassification: text("usage_classification", {
      enum: ["common", "less-than-common", "rarely-used"],
    }),

    // NOTE: keep these AFTER the columns above. The haniverse-worker deploy loads static.db into D1
    // with a positional `sqlite3 .dump`, so the column order created from this schema must match
    // D1's. These were added to D1 via `ALTER TABLE ADD` (appended), in this exact order, so any
    // column introduced after the initial migration must be declared at the end here too.
    commonCount: integer("common_count").notNull(),
    lessThanCommonCount: integer("less_than_common_count").notNull(),
    rank: integer("rank").notNull(),
    rarelyUsedCount: integer("rarely_used_count").notNull(),
  },
  (table) => [index("grapheme_tw_data_grapheme_id_idx").on(table.graphemeId)],
);

export type GraphemeTwData = typeof graphemeTwDataTable.$inferSelect;
